import axios from '../../../api/axiosConfig';
import { setIsDisconnected } from './setDisconnectAction';
import { getItem, removeItem } from '../../../utils/storageHelper';

export const DISCONNECT_CALENDAR_REQUEST = 'DISCONNECT_CALENDAR_REQUEST';
export const DISCONNECT_CALENDAR_SUCCESS = 'DISCONNECT_CALENDAR_SUCCESS';
export const DISCONNECT_CALENDAR_FAILURE = 'DISCONNECT_CALENDAR_FAILURE';

const disconnectCalendarRequest = () => ({
    type: DISCONNECT_CALENDAR_REQUEST,
});

const disconnectCalendarSuccess = () => ({
    type: DISCONNECT_CALENDAR_SUCCESS,
});

const disconnectCalendarFailure = (error) => ({
    type: DISCONNECT_CALENDAR_FAILURE,
    payload: error,
});

/**
 * Thunk Action: disconnectCalendar
 *
 * @param {object} json - The options for the disconnect request.
 * @param {boolean} json.permanentlyRemove - Flag to permanently remove the calendar.
 */
export const disconnectCalendar = (params ) => {
    // The thunk returns a single async function that receives dispatch
    return async (dispatch) => {
        dispatch(disconnectCalendarRequest());

        try {
            const providerType = await getItem("calendarProvider");

            const response = await axios.post(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Calendar/disconnectCalendar`,
                { PermanentlyRemove: params.PermanentlyRemove, ProviderType: providerType },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                await removeItem("calendar");
                await removeItem("calendar_access_token");
                await removeItem("calendarProvider");
                dispatch(disconnectCalendarSuccess());
                dispatch(setIsDisconnected(true));
            } else {
                throw new Error(`Request failed with status ${response.status}`);
            }
        } catch (error) {
            dispatch(disconnectCalendarFailure(error.message || 'An unknown error occurred'));
        }
    };
};
